import React from "react";
import HeroNousSommes from "../../Components/HeroNousSommes/HeroNousSommes";
import InnovationSection from "../../Components/InnovationSection/InnovationSection";
import VisionMissionSection from "../../Components/VisionMissionSection/VisionMissionSection";
import ValuesSection from "../../Components/ValuesSection/ValuesSection";
import AboutExpertise from "../../Components/AboutExpertise/AboutExpertise";
import AboutMethod from "../../Components/AboutMethod/AboutMethod";
import NewValuesSection from "../../Components/NewValuesSection/NewValuesSection";
import AboutFinalCTA from "../../Components/AboutFinalCTA/AboutFinalCTA";

export default function Nous_Sommes() {
  return (
    <main>
      <HeroNousSommes />
      <VisionMissionSection />
      <ValuesSection />
      <AboutExpertise/>
      <AboutMethod />
      <NewValuesSection />
      <AboutFinalCTA />
    </main>
  );
}